import { useMemo, useState } from "react";

function hostOf(url: string) {
  try {
    return new URL(url.startsWith("http") ? url : `https://${url}`).hostname.replace(/^www\./, "");
  } catch {
    return "";
  }
}

/** Logo situs (favicon) dengan skeleton + lazy load — fallback ke inisial nama. */
export function ListingThumb({
  url,
  name,
  size = 44,
  className = "",
}: {
  url: string;
  name: string;
  size?: number;
  className?: string;
}) {
  const host = useMemo(() => hostOf(url), [url]);
  const [state, setState] = useState<"loading" | "ready" | "failed">("loading");
  const src = host ? `https://www.google.com/s2/favicons?domain=${host}&sz=128` : "";
  const initials = name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");

  return (
    <span
      className={`relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-xl border border-border bg-secondary transition-transform duration-300 group-hover:scale-105 ${className}`}
      style={{ width: size, height: size }}
      aria-hidden
    >
      {src && state !== "failed" ? (
        <>
          {state === "loading" && <span className="absolute inset-0 animate-pulse bg-muted" />}
          <img
            src={src}
            alt=""
            loading="lazy"
            decoding="async"
            width={size}
            height={size}
            onLoad={() => setState("ready")}
            onError={() => setState("failed")}
            className={`size-full object-contain p-1.5 transition-opacity duration-300 ${
              state === "ready" ? "opacity-100" : "opacity-0"
            }`}
          />
        </>
      ) : (
        <span className="font-display text-sm font-semibold text-muted-foreground">{initials || "?"}</span>
      )}
    </span>
  );
}
